import { camelCase } from 'change-case';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { isRequestError } from '~/common/services/requests';
import { ApiErrorPayload } from '../types/ApiErrorPayload';
import { hasErrorsMap } from './hasErrorsMap';

export const handleValidationErrorResponse = <T extends FieldValues>(
  err: unknown,
  setError: UseFormSetError<T>,
  keyPrefix = '',
  keyTransformer: (key: string) => string = camelCase,
): void => {
  if (
    !isRequestError<ApiErrorPayload>(err) ||
    err.response?.status !== 422 ||
    !hasErrorsMap(err.response.data)
  ) {
    return;
  }
  const { errors } = err.response.data;
  Object.keys(errors).forEach((key) => {
    const messages = errors[key];
    setError(`${keyPrefix}${keyTransformer(key)}` as Path<T>, {
      type: 'server',
      message: Array.isArray(messages) ? messages[0] : messages,
    });
  });
};
